import { CustomFieldTab } from 'src/app/modules/personnel-files/custom-fields/models/CustomFieldTab';

export class MenuItem {

  constructor(page: MenuItem) {
    if (page == null) {
      return;
    }

    this.id = page.id;
    this.cssClass = page.cssClass;
    this.url = page.url;
    this.label = page.label;
    this.isActive = page.isActive;
    this.hasActiveTrail = page.hasActiveTrail;
    this.isMenuItemContainerWithoutPage = page.isMenuItemContainerWithoutPage;
    this.hideInNavigation = page.hideInNavigation;
    this.hasVisibleSubpages = false;
    this.sortOrder = page.sortOrder;
    this.crmModuleIds = page.crmModuleIds;

    this.subPages = [];
    for (const sub of page.subPages) {
      this.subPages.push(new MenuItem(sub));
      if (!sub.hideInNavigation) {
        this.hasVisibleSubpages = true;
      }
    }

    for (const sub of this.subPages) {
      sub.parent = page;
      for (const sub2 of sub.subPages) {
        sub2.parent = sub;
        for (const sub3 of sub2.subPages) {
          sub3.parent = sub2;
          for (const sub4 of sub3.subPages) {
            sub4.parent = sub3;
            for (const sub5 of sub4.subPages) {
              sub5.parent = sub4;
            }
          }
        }
      }
    }
  }

  id: number;
  parentID: number;
  label: string;
  url: string;
  subPages: MenuItem[];
  parent?: MenuItem;
  isActive?: boolean;
  hasActiveTrail?: boolean;
  isMenuItemContainerWithoutPage: boolean;
  hideInNavigation: boolean;
  cssClass: string;
  sortOrder: number;
  crmModuleIds?: string;

  // Use for custom field tabs: 
  isCustom?: boolean;
  customFieldTab?: CustomFieldTab;
  angularComponent?: string;

  // Only used for top navigation icons
  customIcon?: any;
  customCssIcon?: any;
  cssIcon?: any | string;

  // Only used for breadcrumb
  angularUrl?: string;
  showChildren?: boolean;
  hasVisibleSubpages?: boolean;

  public getAngularUrl(subPage?: MenuItem): string {
    subPage = subPage || this;
    let url: string = subPage.url;

    if (
      subPage.subPages &&
      subPage.subPages.length &&
      subPage.isMenuItemContainerWithoutPage
    ) {
      let firstAccessibleSubpage = subPage.subPages.filter(e => !e.hideInNavigation)[0];
      if (
        firstAccessibleSubpage &&
        firstAccessibleSubpage.subPages &&
        firstAccessibleSubpage.subPages.length &&
        firstAccessibleSubpage.isMenuItemContainerWithoutPage
      ) {
        url = this.getAngularUrl(firstAccessibleSubpage);
      } else {
        url = firstAccessibleSubpage?.url || "";
      }
    }

    return url;
  }
}

export interface BreadCrumbNavigation {
  levels: BreadCrumbNavigationLevel[];
}

export interface BreadCrumbNavigationLevel {
  activeMenuItem: MenuItem;
  menuItems: MenuItem[];
}
